import API from './API.js'
import axios from 'axios'

export default class Rooms extends API {
  constructor() {
    super('rooms')
  }

  async onlineSessions() {
    const response = await axios.get(`/${this.route}/onlineSessions`)
    return response.data
  }
   async saveRoomsUser(id,params) {
    const response = await axios.get(`/rooms/saveRoomsUser/${id}`, { params })
    return response.data
  }
}
